import axios from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
// axios.defaults.baseURL= process.env.REACT_APP_BACKURL


export const ALL_PROJECTS = createAsyncThunk(
    'ALL_PROJECTS', async () => {
        try {
            const projects = await axios.get('/minted')
            return projects.data
        } catch (error) {
            console.log(error)
            return error
        }
    }
)


export const VENTORY_PROJECTS = createAsyncThunk(
    'VENTORY_PROJECTS', async () => {
        try {
            const projects = await axios.get('/ventory')
            return projects.data
        } catch (error) {
            console.log(error)
            return error
        }
    }
)

export const UPCOMING_PROJECTS = createAsyncThunk(
    'UPCOMING_PROJECTS', async () => {
        try {
            const projects = await axios.get('/upcoming')
            // console.log(projects.data)
            return projects.data
        } catch (error) {
            console.log(error)
            return error
        }
    }
)

export const HYPE = createAsyncThunk(
    'HYPE', (type) => {
        return type
    }
)

export const SORT_USER_LIKES = createAsyncThunk(
    'SORT_USER_LIKES', (type) => {
        return type
    }
)

export const COMMUNITY = createAsyncThunk(
    'COMMUNITY', (type) => {
        return type
    }
)
export const SORT_NUMBER = createAsyncThunk(
    'SORT_NUMBER', (type) => {
        return type
    }
)

export const MARKET_CAP = createAsyncThunk(
    "MARKET_CAP", ()=>{
        return
    }
)
export const VOLUME_HS = createAsyncThunk(
    "VOLUME_HS", ()=>{
        return
    }
)

export const SUPPLY = createAsyncThunk(
    "SUPPLY", ()=>{
        return
    }
)

export const FLOOR_PRICE = createAsyncThunk(
    "FLOOR_PRICE", ()=>{
        return
    }
)

export const LIKE_PROJECT = createAsyncThunk(
    'LIKE_PROJECT', async (likedProjects) => {
        try {
            
            return likedProjects
        } catch (error) {
            console.log(error)
            return error
        }
    }
)


export const SAVE_LIKES = createAsyncThunk(
    'SAVE_LIKES', async (likes) => {
        try {
            const projects = await axios.post('/likes', likes)
            console.log(projects.data)
            console.log(projects.data)
            return projects.data
        } catch (error) {
            console.log(error)
            return error
        }
    }
)


export const LOGIN = createAsyncThunk(
    'LOGIN', async (login) => {
        try {
            const userInfo = await axios.get(`/user/?id=${login.id}`)
            return userInfo.data
        } catch (error) {
            console.log(error)
            return error
        }
    }
)